import { render, staticRenderFns } from "./word-cloud.vue?vue&type=template&id=6c84c2ea"
import script from "./word-cloud.vue?vue&type=script&lang=js"
export * from "./word-cloud.vue?vue&type=script&lang=js"
import style0 from "./word-cloud.vue?vue&type=style&index=0&id=6c84c2ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports